import { render, staticRenderFns } from "./MeasureAdmin.vue?vue&type=template&id=5974e413&"
import script from "./MeasureAdmin.vue?vue&type=script&lang=js&"
export * from "./MeasureAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports